// @ts-nocheck
import * as React from "react";

const ECommerceOutline: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
            <path
                d="M35.1 43.9v5.4c0 1.9 1.6 3.5 3.5 3.5h10.6c1.9 0 3.5-1.6 3.5-3.5v-5.4c1-.4 1.8-1.3 1.8-2.5v-1.8c0-.5-.4-.9-.9-.9h-3.9l-3.3-4.9c-.3-.4-.8-.5-1.2-.2s-.5.8-.2 1.2l2.6 3.9h-7.3l2.6-3.9c.3-.4.2-1-.2-1.2-.4-.3-1-.2-1.2.2l-3.3 4.9h-3.9c-.5 0-.9.4-.9.9v1.8c-.1 1.1.6 2.1 1.7 2.5m15.8 5.4c0 1-.8 1.8-1.8 1.8H38.6c-1 0-1.8-.8-1.8-1.8V44h14.1zm-15.8-8.8h17.6v.9c0 .5-.4.9-.9.9H35.9c-.5 0-.9-.4-.9-.9.1 0 .1-.9.1-.9"
                fill="currentColor"
                strokeWidth="2"
            />
            <path
                d="M40.3 49.3c.5 0 .9-.4.9-.9v-1.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9v1.8c.1.5.4.9.9.9M43.9 49.3c.5 0 .9-.4.9-.9v-1.8c0-.5-.4-.9-.9-.9s-.9.5-.9 1v1.8c0 .4.4.8.9.8M47.4 49.3c.5 0 .9-.4.9-.9v-1.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9v1.8c0 .5.4.9.9.9M57.1 38.7h10.6c.5 0 .9-.4.9-.9s-.5-.8-1-.8H57.1c-.5 0-.9.4-.9.9 0 .4.4.8.9.8M57.1 44h10.6c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H57.1c-.5 0-.9.4-.9.9s.4.9.9.9M65 49.3c0-.4-.2-.7-.6-.8l-7-2.6c-.3-.1-.7 0-.9.2s-.3.6-.2.9l2.6 7c.1.3.5.6.8.6.4 0 .7-.2.8-.5l.8-1.9 2.2 2.2c.3.3.9.3 1.2 0s.3-.9 0-1.2L62.5 51l1.9-.8q.6-.3.6-.9m-4.4.5c-.2.1-.4.2-.5.5l-.4 1-1.2-3.1 3.1 1.2z"
                fill="currentColor"
                strokeWidth="2"
            />
            <path
                d="M70.3 29.9H31.5c-1.9 0-3.5 1.6-3.5 3.5v26.4c0 1.9 1.6 3.5 3.5 3.5h13.9l-.6 3.5H43c-.5 0-.9.4-.9.9s.4.9.9.9h15.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-1.9l-.6-3.5h13.9c1.9 0 3.5-1.6 3.5-3.5V33.5c.1-2-1.5-3.6-3.4-3.6m-38.8 1.8h38.7c1 0 1.8.8 1.8 1.8v22.9H29.8V33.5c0-1 .8-1.8 1.7-1.8m23.6 35.2h-8.5l.6-3.5h7.3zm15.2-5.3H31.5c-1 0-1.8-.8-1.8-1.8V58H72v1.8c0 1-.8 1.8-1.7 1.8"
                fill="currentColor"
                strokeWidth="2"
            />
        </svg>
    );
};

export default React.memo(ECommerceOutline);
